import { User } from '../types'
import { getRequest, getRequestStatus, postRequest } from 'features/common'
import settings from 'settings'
import { User as Auth0User } from '@auth0/auth0-react'

function baseUrl() {
  const { accountsApiUrl } = settings
  return `${accountsApiUrl}/users`
}

export const getCurrentUser = async (): Promise<User> => {
  return await getRequest(`${baseUrl()}/me`)
}

export const getCurrentUserFromAuth0 = async (): Promise<User> => {
  return await getRequest(`https://${settings.domain}/userinfo`).then((user: Auth0User) => {
    return {
      app_metadata: user['http://app.carto.com/app_metadata'] || {},
      email: user.email || '',
      email_verified: user.email_verified || false,
      user_id: user.sub || '',
      user_metadata: user['http://app.carto.com/user_metadata'] || {},
      identities: user.identities || [],
      name: user.name || '',
      nickname: user.nickname || '',
      created_at: user.created_at || ''
    }
  })
}

export const addCartoDwGrant = async ({ email }: { email: string }): Promise<void> => {
  await postRequest(`${baseUrl()}/dw-access-grant`, { email })
}

export const revokeCartoDwGrant = async ({ email }: { email: string }): Promise<void> => {
  await postRequest(`${baseUrl()}/dw-access-revoke`, { email })
}

export const checkAccountIsReadyStatusInWorkspace = async (id: string): Promise<number> => {
  const { workspaceApiUrl } = settings

  const status = await getRequestStatus(`${workspaceApiUrl}/accounts/${id}/check`)
  return status
}

export const userLoginMetrics = async (user: User): Promise<void> => {
  const { workspaceApiUrl } = settings

  const metricsEndpointUrl = `${workspaceApiUrl}/events`
  await postRequest(metricsEndpointUrl, {
    event_type: 'UserLogins',
    payload: {
      accountId: user.user_metadata.account_id,
      userId: user.user_id
    },
    timestamp: new Date()
  })
}
